export default __webpack_public_path__ + "static/media/hamburger--open.eca2eb12.svg";